export default function getStyles() {
  return {
    marginContainer: {
      marginLeft: 32,
      marginTop: 32,
      paddingRight: 30,
      display: 'flex',
      overflow: 'auto',
      flex: '1 0 1px',
      flexDirection: 'column',
      '& .file-text': {
        overflow: 'hidden',
      },
      '& .ms-ProgressIndicator': {
        width: 1000,
      },
      '& .upload-err-info': {
        margin: '10px 0',
        paddingLeft: 0,
        width: 1000,
        paddingRight: 0,
        '& p': {
          marginBottom: 0,
        },
      },
    },
  };
}
